import _get from 'lodash/get'

import { FIELD_TYPE } from '@/constants'

import { setExpensesTotal } from './helper/expenseTotal'

export default [
  {
    label: 'Monthly Expenses',   
    type: FIELD_TYPE.HEADING
  }, 
  {
    apiKey: 'expenses.rentMortgage',
    label: 'Rent/Mortgage/Lot Rent',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.CURRENCY,
    onFieldSet(value, application, store) {
      setExpensesTotal(value, application) 
  }
  },
  {
    apiKey: 'expenses.food',
    label: 'Food (not including food stamps)',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.CURRENCY,
    onFieldSet(value, application, store) {
      setExpensesTotal(value, application) 
  }
  },
  {
    apiKey: 'expenses.carPayment',
    label: 'Car Payment',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.CURRENCY,
    onFieldSet(value, application, store) {
      setExpensesTotal(value, application) 
  }
  },
  {
    apiKey: 'expenses.carInsurance',
    label: 'Car Insurance',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.CURRENCY,
    onFieldSet(value, application, store) {
      setExpensesTotal(value, application) 
  }
  },
  {
    apiKey: 'expenses.transport',
    label: 'Transportation Expense',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.CURRENCY,
    onFieldSet(value, application, store) {
      setExpensesTotal(value, application) 
  }
  },
  {
    apiKey: 'expenses.childCare',
    label: 'Childcare',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.CURRENCY,
    onFieldSet(value, application, store) {
      setExpensesTotal(value, application) 
  }
  },
  {
    apiKey: 'expenses.cable',
    label: 'Cable',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.CURRENCY,
    onFieldSet(value, application, store) {
      setExpensesTotal(value, application) 
  }
  },
  {
    apiKey: 'expenses.internet',
    label: 'Internet',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.CURRENCY,
    onFieldSet(value, application, store) {
      setExpensesTotal(value, application) 
  }
  },
  {
    apiKey: 'expenses.diapers',
    label: 'Diapers',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.CURRENCY,
    onFieldSet(value, application, store) {
      setExpensesTotal(value, application) 
  }
  },
  {
    apiKey: 'expenses.water',
    label: 'Water',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.CURRENCY,
    onFieldSet(value, application, store) {
      setExpensesTotal(value, application) 
  }
  },
  {
    apiKey: 'expenses.electricity',
    label: 'Electricity',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.CURRENCY,
    onFieldSet(value, application, store) {
      setExpensesTotal(value, application) 
  }
  },
  {
    apiKey: 'expenses.gas',
    label: 'Gas',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.CURRENCY,
    onFieldSet(value, application, store) {
      setExpensesTotal(value, application) 
  }
  },
  {
    apiKey: 'expenses.telephone',
    label: 'Telephones',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.CURRENCY,
    onFieldSet(value, application, store) {
      setExpensesTotal(value, application) 
  }
  },
  {
    apiKey: 'expenses.laundry',
    label: 'Laundry',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.CURRENCY,
    onFieldSet(value, application, store) {
      setExpensesTotal(value, application) 
  }
  },  
  {
    apiKey: 'expenses.houseHoldItems',
    label: 'Household Items',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.CURRENCY,
    onFieldSet(value, application, store) {
      setExpensesTotal(value, application) 
  }
  },
  {
    apiKey: 'expenses.total',
    label: 'Total Montly Expenses',
    placeHolder: '',    
    disabled: true,
    type: FIELD_TYPE.CURRENCY
  },
  {
    apiKey: 'expenses.otherKnownExpenses',
    label: 'Are there any other expenses you would like us to consider, if so, please describe them here:',
    placeHolder: '',
    required: true,
    type: FIELD_TYPE.TEXTAREA
  },
]